// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__xq8uW","tab":"tabs_tab__ppHjM","active":"tabs_active__zdAau"};